import { object, string } from 'yup';
import i18n from '../../../../i18n';

export const OTModalSchema = object({
  state: string().required(() => i18n.t('validation:required')),
});
